/**
 * Map last AI generate state → generation-prompt-preview query (SMS campaigns)
 * For Media Devoted | Created By Ciro Autiero
 */

export function resolveAiGeneratePreviewParams(input: {
  lastGroupId: string;
  groupIdsPerDrop: string[];
  countryKey: string;
  perDropBatches: string[][] | null;
  generatedTexts: string[];
  amountPerDrop: number;
}): { groupId: string; countryKey: string; amount: number } | null {
  const { lastGroupId, groupIdsPerDrop, countryKey, perDropBatches, generatedTexts, amountPerDrop } =
    input;
  const groupId = perDropBatches?.length
    ? (groupIdsPerDrop[0]?.trim() || lastGroupId)
    : lastGroupId;
  if (!groupId?.trim()) return null;
  const rawAmount = perDropBatches?.length
    ? (perDropBatches[0]?.length ?? amountPerDrop)
    : (generatedTexts.length || 1);
  const amount = Math.min(15, Math.max(1, rawAmount));
  return { groupId: groupId.trim(), countryKey, amount };
}
